import { render, staticRenderFns } from "./MyGoals.vue?vue&type=template&id=25127580&"
import script from "./MyGoals.vue?vue&type=script&lang=js&"
export * from "./MyGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports